module.exports = __webpack_public_path__ + "static/Roles-963f43b9eaf3c5af98bc6d91057f256c.png";